import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

// 以下追加したもの
import { Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { AuthService } from '@app/services/auth.service';


@Injectable()
export class AuthGuard  {

  constructor(
    private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.user.pipe(
      take(1),
      map(user => !!user), // userが取得できた場合はtrueを返す
      tap(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/home/login'], {relativeTo: this.route });
        }
      })
    );
  }
}
